import { css } from '@emotion/core';

const styles = {
  actionsContainer: css`
    width: 100%;
    & .MuiButton-contained {
      // exact padding of text variant button.
      margin-bottom: 12px;
    }
  `,
  textAction: css`
    // exact padding of text variant button.
    padding-top: 12px;
    padding-bottom: 12px;
  `,
};

export default styles;
